import { render, staticRenderFns } from "./HouseSpecification.vue?vue&type=template&id=67b091a4&"
import script from "./HouseSpecification.vue?vue&type=script&lang=js&"
export * from "./HouseSpecification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports